export default "__VITE_ASSET__Bvn9yAoZ__"